import ChipRow from "./chip-row";

// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
export default function HelpSheet({
  open,
  isProFeaturesLocked,
  preservePitchMode = false,
  onPreservePitchModeChange,
  speedUpMode = false,
  onSpeedUpModeChange,
  detachedPanel = false,
  onDetachedPanelChange,
  onResetClick,
  onShortcutsClick,
  onChangelogClick,
  onUpgradeClick,
}) {
  const locked = !!isProFeaturesLocked;

  const items = [
    {
      key: "version",
      label: `v${process.env.VERSION}`,
      title: "See what is new in this version",
      onClick: onChangelogClick,
      enabled: true,
    },
    {
      key: "pitch-lock",
      label: "Pitch Lock",
      title: locked
        ? "Pitch Lock is a Pro feature"
        : preservePitchMode
          ? "Keep the original pitch when slowing"
          : "Drop the pitch with the speed",
      // Never reads as on while locked, even if it was left on before.
      selected: !locked && !!preservePitchMode,
      locked,
      onClick: () =>
        locked
          ? onUpgradeClick?.()
          : onPreservePitchModeChange?.(!preservePitchMode),
      enabled: true,
    },
    {
      key: "speed-up",
      label: "Fast Mode",
      title: locked
        ? "Fast Mode is a Pro feature"
        : speedUpMode
          ? "Slow Control is speeding the video up"
          : "Turn Slow Control into a fast control",
      // Never reads as on while locked, even if it was left on before.
      selected: !locked && !!speedUpMode,
      locked,
      onClick: () =>
        locked ? onUpgradeClick?.() : onSpeedUpModeChange?.(!speedUpMode),
      enabled: true,
    },
    {
      key: "shortcuts",
      label: "Shortcuts",
      onClick: onShortcutsClick,
      enabled: !locked,
    },
    {
      key: "reset",
      label: "Reset Controls",
      title: "Put every control back to its default",
      onClick: onResetClick,
      enabled: true,
    },
    {
      key: "detach",
      // Free for everyone: it only changes where the popup is drawn.
      label: detachedPanel ? "Attach Popup" : "Detach Popup",
      title: detachedPanel
        ? "Go back to the normal extension popup"
        : "Open Slowed as a panel inside the page",
      selected: detachedPanel,
      onClick: () => onDetachedPanelChange?.(!detachedPanel),
      enabled: true,
    },
  ].filter((item) => item.enabled);

  return (
    <div
      id="mood-sheet"
      className={`mood mood--help${open ? " mood--open" : ""}`}
      aria-label="Advanced"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Advanced</div>
        <p className="mood__subtitle">
          Pitch lock, speed direction, shortcuts, and popup options.
        </p>
      </div>

      <ChipRow>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`mood__chip${item.selected ? " mood__chip--selected" : ""}${
              item.locked ? " mood__chip--locked" : ""
            }`}
            onClick={() => item.onClick?.()}
            title={item.title || item.label}
            aria-disabled={item.locked || undefined}
            {...(item.selected != null
              ? { "aria-pressed": !!item.selected }
              : {})}
            tabIndex={open ? 0 : -1}
          >
            <span className="mood__chip-name">{item.label}</span>
          </button>
        ))}
      </ChipRow>
    </div>
  );
}
